/**
 * REFERANS (HEDİYE) KODU: biçim kuralı ve geçerlilik hesabının TEK KAYNAĞI
 * (referans kodu kapsamı 12.10.2026 · Story 1, 2, 3; kullanıcı onaylı).
 *
 * Personel panelde kod tanımlar (`originn100` = 1 hediye kredi). Kurum, web
 * kredi talep formunda kodu isteğe bağlı yazar; kurumun gördüğü HİÇBİR yanıt
 * kodun geçerliliğini söylemez (kod tahmini kâhini yok, soru 7). Geçerlilik
 * yalnız panelde, satış adayı detayında hesaplanır (`resolveReferralCodeStatus`).
 *
 * Joi'siz: panel ve web formu aynı biçim kuralını kökten okur, sunucu şeması
 * (`contracts/panel-referral-code.ts`) ve veritabanı CHECK'i aynı değeri kullanır.
 */
/** Ad ve hediye sınırları (soru 8). Veritabanı CHECK'leri aynı sayıları taşır. */
export const REFERRAL_CODE_LIMITS = {
    nameMin: 4,
    nameMax: 32,
    giftMin: 1,
    giftMax: 12,
    note: 500,
};
/** Saklanan (kanonik) adın biçimi: yalnız ASCII küçük harf ve rakam, 4-32. */
export const REFERRAL_CODE_PATTERN = /^[a-z0-9]{4,32}$/;
/**
 * KANONİK BİÇİM: kenar boşluğu atılır, YALNIZ ASCII `A-Z` küçültülür.
 *
 * `toLowerCase` / `toLocaleLowerCase` KULLANILMAZ: süreç yerel ayarı `tr_TR`
 * iken `toLocaleLowerCase` `I`yı noktasız `ı`ya çevirir (`ORIGINN100` →
 * `orıgınn100`) ve Joi'nin `lowercase()` kuralı tam olarak bunu çağırır.
 * Burada ASCII dışı harf (`ı`, `İ`, `ş`) DOKUNULMADAN kalır ve biçim kuralına
 * takılır: kod yerel ayardan bağımsız tek biçimde saklanır.
 */
export function canonicalReferralCode(raw) {
    return raw.trim().replace(/[A-Z]/g, (letter) => String.fromCharCode(letter.charCodeAt(0) + 32));
}
/** Kanonik biçimde geçerli mi (form ve sunucu aynı kuralı okur). */
export function isReferralCodeFormat(raw) {
    return REFERRAL_CODE_PATTERN.test(canonicalReferralCode(raw));
}
/**
 * Satış adayındaki kodun bu kurum için durumu (Story 3, sekiz vaka). Sıra
 * bilinçlidir: önce yüklemeyi imkânsız kılan olgular (kurum yok, kod yok),
 * sonra bu kurumun kendi geçmişi (kullanılmış), sonra kampanyanın hâli.
 */
export const REFERRAL_CODE_STATUSES = [
    'valid',
    'not_found',
    'inactive',
    'not_started',
    'expired',
    'cap_reached',
    'already_used',
    'no_organization',
];
/**
 * DURUM HESABI (soru 4 kararı):
 *  · tarih penceresi TALEP ANINA göre: kurum kodu geçerliyken yazdıysa satış
 *    ekibinin gecikmesi kurumu cezalandırmaz (talepte geçerli, bugün süresi
 *    dolmuş kod `valid`);
 *  · aktiflik, toplam tavan ve "kurum başına bir kez" BUGÜNE göre
 *    (kampanyayı durdurma hakkı).
 * Pencere sınırları kredi kuralıyla aynıdır: başlangıç İstanbul gün başı,
 * bitiş İstanbul gün sonu (`creditDayEnd`), bitiş anı DAHİL.
 */
export function resolveReferralCodeStatus(input) {
    if (input.organizationId === null)
        return 'no_organization';
    const { code } = input;
    if (code === null)
        return 'not_found';
    if (input.usedAt !== null)
        return 'already_used';
    if (!code.active)
        return 'inactive';
    const at = input.requestedAt.getTime();
    if (code.startsAt !== null && at < code.startsAt.getTime())
        return 'not_started';
    if (code.endsAt !== null && at > code.endsAt.getTime())
        return 'expired';
    if (code.usageCap !== null && code.usageCount >= code.usageCap)
        return 'cap_reached';
    return 'valid';
}
/**
 * PANEL LİSTESİNDEKİ DURUM ETİKETİ (P7 · "Durum etiketi önceliği"). Satış
 * adayındaki hesaptan (`resolveReferralCodeStatus`) AYRIDIR: orada bir kurum
 * ve talep anı vardır, burada yalnız kodun kendisi ve BUGÜN vardır.
 *
 * ÖNCELİK TEK YERDE ve sırası tasarımdan gelir:
 *   Pasif > Başlamadı > Süresi doldu > Tavan doldu > Aktif
 * Anahtar kapalıysa diğer koşullara bakılmaz. Pencere sınırları kredi
 * kuralıyla aynıdır: sunucu `startsAt`ı İstanbul gün başı, `endsAt`ı İstanbul
 * gün sonu olarak yazar ve bitiş anı DAHİLDİR.
 */
export const REFERRAL_CODE_LIST_STATUSES = [
    'inactive',
    'not_started',
    'expired',
    'cap_reached',
    'active',
];
function instantOf(value) {
    return typeof value === 'string' ? Date.parse(value) : value.getTime();
}
export function resolveReferralCodeListStatus(code, now) {
    if (!code.active)
        return 'inactive';
    const at = now.getTime();
    if (code.startsAt !== null && at < instantOf(code.startsAt))
        return 'not_started';
    if (code.endsAt !== null && at > instantOf(code.endsAt))
        return 'expired';
    if (code.usageCap !== null && code.usageCount >= code.usageCap)
        return 'cap_reached';
    return 'active';
}
//# sourceMappingURL=referral-code.js.map